// 1. Skillboard.tsx - Mit Debug Logging
import React from "react";
import useScreenSize, { MOBILE_BREAKPOINT } from "hooks/ScreenSize";
import DesktopSkillboard from "./DesktopSkillboard";
import MobileSkillboard from "./mobile/MobileSkillboard";

const Skillboard: React.FC = () => {
  console.log("🔍 Skillboard rendering...");
  
  const { width } = useScreenSize();
  const isMobile = width <= MOBILE_BREAKPOINT;
  
  console.log(`📱 Screen width: ${width}px, isMobile: ${isMobile}`);

  return isMobile ? <MobileSkillboard /> : <DesktopSkillboard />;
};

export default Skillboard;



